import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useDispatch } from "react-redux";
import { socialLogin } from "../redux/slices/authSlice"; // ✅ same action as Facebook

const UseGoogleLogin = () => {
  const dispatch = useDispatch();

  const params = new URLSearchParams(window.location.search);
  const referralCode = params.get("ref");

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          },
        );

        const googleUser = res?.data;

        const socialLoginData = {
          provider: "google",
          provider_id: googleUser.sub, // Google unique ID
          name: googleUser.name,
          email: googleUser.email,
          email_verified: googleUser.email_verified, // backend only links accounts when verified
          google_access_token: tokenResponse.access_token, // stored for revocation on account deletion
          device_type: "web",
          // username: googleUser.email, // if required by backend
          ...(referralCode?.trim() ? { referred_code: referralCode } : {}),
        };

        const result = await dispatch(socialLogin(socialLoginData)).unwrap();

        console.log(" Google social login result:", result);
      } catch (err) {
        console.error(" Google login error:", err);
      }
    },
    onError: (errorResponse) => {
      console.error(" Google Login Failed:", errorResponse);
    },
  });

  return login;
};

export default UseGoogleLogin;
